import Index from './Index.vue';

export default {
  path: 'materiais',
  name: 'produto-material',
  component: Index,
};
